<template>
  <div>
    <QuotationHeader :img_header="header_image" header="แก้ไขใบเสนอราคา" link_back="stock/quotation/quotationmain"/>
    <Quotation_edit/>
  </div>
</template>

<script>
import HeaderImage from "@/assets/quotation.png";
import QuotationHeader from "@/components/admin/stock/quotation/header_quotation/QuotationHeader";
import Quotation_edit from "@/components/admin/stock/quotation/Quotation_edit";

export default {
  name: "QuotationEdit",
  components: {
    Quotation_edit,
    QuotationHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
